	<template>
	<div id="upload">
		<b-container class="wrapper">
			<b class='celular-ok'>
				<img
          v-if="svgIcon"
          :src="svgIcon"
          :alt="`icone ${device.deviceTypeName}`"
        />
				<p class="parabens-compra">Cadastre seu {{ lblIdentification }}</p>
			</b>
			<p class="receber-email">
				Para a validação final de seu seguro {{ device.deviceTypeName }}, precisamos que nos envie o <span>{{ lblIdentification }}*</span> do seu aparelho.
			</p>
			<p class="documentos-pendentes">
				Siga as instruções clicando nos botões abaixo.
			</p>
      <b-row>
				<b-col>
          <template v-if="mounted">
            <b-button class="quero-proteger"
              v-if="confirmDeviceIdentification"
              @click="tracking"
              pill
              :disabled="true"
              variant="success"
            >
              <img src="../../assets/svg/path.svg" alt="">
              <span>&nbsp;DOCUMENTO CADASTRADO</span>
            </b-button>
            <b-button class="quero-proteger"
              v-else-if="!confirmDeviceIdentification"
              pill
              v-b-modal.modalDeviceIdentification
              variant="danger"
            >
              <img src="../../assets/svg/warning.svg" alt="">
              <span>&nbsp;CADASTRAR DOCUMENTO</span>
            </b-button>
          </template>
				</b-col>
			</b-row>
		</b-container>
		<b-modal
			id="modalDeviceIdentification" size="lg"
			centered
			hide-footer
			body-bg-variant="white">
			<ImeiCadastro v-if="device.deviceTypeName === 'celular'" v-on:confirmDeviceIdentification="handleIMEI" />
      <SerialNumberRegistration v-else v-on:confirmDeviceIdentification="handleIMEI" />
		</b-modal>
		<b-modal
			id="MODAL_SUCESSO" size="lg"
			centered
			hide-footer
			body-bg-variant="white">
			<ImeiSucesso v-if="device.deviceTypeName === 'celular'" />
      <SerialNumberSuccess v-else/>
		</b-modal>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import './Upload.css'
import ImeiCadastro from '../ImeiCadastro/ImeiCadastro'
import ImeiSucesso from '../ImeiSucesso/ImeiSucesso'
import SerialNumberRegistration from '../SerialNumberRegistration'
import SerialNumberSuccess from '../SerialNumberSuccess'

export default {
	name: 'Upload',
	data () {
		return {
			modalImei: false,
			IMEI: '',
			confirmDeviceIdentification: false,
      mounted: false
		}
	},
	components: {
		ImeiCadastro,
    SerialNumberRegistration,
    ImeiSucesso,
    SerialNumberSuccess
  },
	created () {
    this.$store.state.device = {
      payment: {
        policyUuid: this.$route.query.id
      },
      deviceTypeName: ''
    }

    axios.get(
      `${process.env.VUE_APP_API_URL}/internal-cell-phones/v1/policy/${this.device.payment.policyUuid}`,
      JSON.parse(sessionStorage.config)
    )
			.then((response) => {
        this.device.deviceTypeName = response.data.item.deviceTypeName.toLowerCase()
				this.serialNumber = response.data.serialNumber
        this.invoiceFileName = response.data.invoiceFileName

				if (!this.serialNumber) {
					this.confirmDeviceIdentification = false
				} else {
					this.confirmDeviceIdentification = true
        }

        this.mounted = true
      })
      .catch(error => {
        this.$sentry.logWithContext({
          ctx: { step: '[step/upload]' }, error
        })
      })
  },
  computed: {
    ...mapState(['device']),
    svgIcon () {
      return this.device.deviceTypeName
        ? require(`@/assets/svg/icon-${this.device.deviceTypeName}-gray-with-shield.svg`)
        : null
    },
    lblIdentification () {
      return (this.device.deviceTypeName && this.device.deviceTypeName === 'celular')
        ? 'IMEI'
        : 'número de série'
    }
  },
	methods: {
		handleIMEI (event) {
      this.$bvModal.hide('modalImei')
      this.disparaDataLayer()
			this.confirmDeviceIdentification = event
		},
    disparaDataLayer () {
			if (this.confirmDeviceIdentification) {
				window.dataLayer.push({
          event: 'afiliattionTag',
          level: 'checkoutPage'
				})
			}
    },
    tracking () {
      window.dataLayer.push({
        event: 'dispositivos-ciclic',
        categoria: 'cadastro-dispositivo',
        acao: this.device.deviceTypeName === 'celular' ? 'IMEI' : 'numero-serie',
        rotulo: '1-continuar'
      })
    }
	}
}
</script>
